import styled from "styled-components";
import { color } from "../shared/styles";

export const RowView = styled.div`
    display: flex;
    padding: 0 12px 0 12px;
    flex: 1;
    overflow: auto;
    gap: 16px;
`;

export const AppContainer = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: ${color.emphasis.NEUTRAL_N5};
    font-family: "Noto Sans";
`;

export const ToastContainer = styled.div`
    font-family: "Noto Sans";
`;